export default "__VITE_ASSET__BtiRFHx___"